const doc = [({"da":({"js":({"admin":({"school_classes":({"index":({"the_school_class_was_deleted":"Klassen blev slettet"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;